<template>
  <el-dialog
    :title="audioContract.status === 2 ? $t('Intercom.ContractExpireDialog.ExpiredTitle') : $t('Intercom.ContractExpireDialog.ExpiringTitle')"
    :visible.sync="isDialogVisible"
    :close-on-press-escape="false"
    :show-close="audioContract.status !== 2"
    :close-on-click-modal="false"
    class="contract-expire-dialog"
    :class="{ 'contract-expire-dialog--iframe': audioContract.status === 3 }"
    @close="handleConfirm"
  >
    <div v-if="audioContract.status === 2" class="contract-expire-dialog__content">
      <div class="contract-expire-dialog__icon">
        <img src="@/assets/img/intercom/intercom-2x.png" alt="intercom" />
      </div>
      <p class="contract-expire-dialog__main">
        {{ $t('Intercom.ContractExpireDialog.Description') }}
      </p>
      <p class="contract-expire-dialog__hint">
        {{ $t('Intercom.ContractExpireDialog.Instruction') }}
      </p>
      <p class="contract-expire-dialog__expire">
        {{ $t('Intercom.ContractExpireDialog.ExpiredAt', { date: displayExpireDate }) }}
      </p>
    </div>
    <div v-else-if="audioContract.status === 3" class="contract-expire-dialog__content">
      <iframe
        :src="iframeSrc"
        frameborder="0"
        scrolling="no"
      ></iframe>
    </div>
    <template v-if="audioContract.status === 2" #footer>
      <el-button
        type="primary"
        round
        class="contract-expire-dialog__confirm"
        @click="handleConfirm"
      >
        {{ $t('Intercom.ContractExpireDialog.Confirm') }}
      </el-button>
    </template>
  </el-dialog>
</template>
<script>
import { mapMutations, mapState, mapGetters } from 'vuex'

export default {
  name: 'ContractExpireDialog',
  computed: {
    ...mapState({
      audioContract: (state) => state.intercom.audioContract,
      contractStats: (state) => state.intercom.contractStats,
      isContractDialogVisible: (state) => state.intercom.isContractDialogVisible
    }),
    ...mapGetters('intercom', ['displayExpireDate']),
    isDialogVisible: {
      get () {
        return this.isContractDialogVisible
      },
      set (value) {
        this.setContractDialogVisible(value)
      }
    },
    iframeSrc () {
      const baseUrl = 'https://access.smartdaily.com.tw/dashboard/contractsAlerts.html'
      const params = this.buildQueryParams()
      return `${baseUrl}?${params}`
    }
  },
  watch: {
    // 觀察合約狀態
    'audioContract.status': {
      async handler (newVal) {
        console.log('audioContract.status', newVal)
        // 如果合約即將到期
        if (newVal === 3) {
          this.$store.commit('intercom/resetContractStats') // 重置合約內的統計數據
          try {
            await this.$store.dispatch('intercom/getContractStatistics') // 取得合約內的統計數據
          } catch (error) {
            console.error('getContractStatistics error', error)
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('intercom', [
      'setContractDialogVisible',
      'setContractAlertBannerShow'
    ]),
    handleConfirm () {
      this.setContractDialogVisible(false)
      this.setContractAlertBannerShow(true)
    },
    /**
     * 建立網址頁面參數
     * @returns {string}
     */
    buildQueryParams () {
      const params = new URLSearchParams()
      params.set('feature', 'intercom')
      const stats = this.contractStats || {}
      Object.keys(stats).forEach((key) => {
        const value = stats[key]
        if (value === undefined || value === null) {
          params.set(key, '')
        } else {
          params.set(key, value)
        }
      })
      return params.toString()
    }
  }
}
</script>
<style lang="scss" scoped>
.contract-expire-dialog {
  ::v-deep .el-dialog {
    @include basicDialog;
    min-width: 680px;
    width: 680px  ;
    .el-dialog__header {
      padding: 18px 24px;
    }
    .el-dialog__title {
      color: $fontColor;
      font-size: map-get($fontSize, xx-large);
      font-weight: 600;
    }
    .el-dialog__body {
      overflow-y: unset;
      padding-top: 48px;
    }

    .el-dialog__footer {
      border-top: unset;
      text-align: center;
      padding-top: 0;
    }
    .el-button span {
      vertical-align: baseline;
    }
  }
  &--iframe {
    ::v-deep .el-dialog {
      .el-dialog__body {
        height: 500px;
        padding: 0 16px 16px;
        max-height: unset;
      }
    }
  }

  &__content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    & iframe {
      width: 100%;
      height: 100%;
    }
  }

  &__icon {
    width: 80px;
    height: 80px;
    margin-bottom: 24px;
    img {
      height: 100%;
    }
  }

  &__main {
    font-size: map-get($fontSize, x-large);
    color: $fontColor;
    margin-bottom: 20px;
  }

  &__hint {
    font-size: map-get($fontSize, medium);
    color: $fontColor;
    margin-bottom: 8px;
  }

  &__expire {
    font-size: map-get($fontSize, medium);
    color: $warnColor;
    font-weight: 600;
  }

  &__confirm {
    min-width: 125px;
    font-weight: 600;
  }
}
</style>
